var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.398,
    height: 17.677,
    viewBox: "0 0 21.398 17.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calificacion",
    transform: "translate(0 -44.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26503",
    "data-name": "Grupo 26503",
    transform: "translate(0.465 44.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7684",
    "data-name": "Trazado 7684",
    d: "M355.985,60.53l-1.911,1,.365-2.128L352.893,57.9l2.137-.31.956-1.936.956,1.936,2.137.31-1.546,1.507.365,2.128Z",
    transform: "translate(-338.61 -55.653)",
    fill: "#fffe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7685",
    "data-name": "Trazado 7685",
    d: "M14.224,60.53l-1.911,1,.365-2.128L11.132,57.9l2.137-.31.956-1.936.956,1.936,2.137.31L15.77,59.407l.365,2.128Z",
    transform: "translate(-11.132 -55.653)",
    fill: "#fffe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7686",
    "data-name": "Trazado 7686",
    d: "M105.851,149.671l-1.265-.184-2.791-.406-.675-.1L99,144.7l-2.116,4.287-4.732.688,3.424,3.337-.808,4.712L99,155.5l4.232,2.225-.808-4.712Z",
    transform: "translate(-88.77 -140.975)",
    fill: "#fffe9f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7687",
    "data-name": "Trazado 7687",
    d: "M95.252,138.546l-1.265-.184a.465.465,0,0,0-.134.921l.333.048-2.749,2.679a.465.465,0,0,0-.134.412l.649,3.783-3.4-1.786a.465.465,0,0,0-.433,0l-3.4,1.786.649-3.783a.465.465,0,0,0-.134-.412l-2.749-2.679,3.8-.552a.465.465,0,0,0,.35-.254l1.7-3.442,1.7,3.442a.465.465,0,0,0,.35.254l.675.1a.465.465,0,1,0,.134-.921l-.433-.063-2.008-4.068a.465.465,0,0,0-.834,0l-2.008,4.068-4.489.652a.465.465,0,0,0-.258.793l3.249,3.167-.767,4.471a.465.465,0,0,0,.675.49l4.016-2.111,4.016,2.111a.465.465,0,0,0,.675-.49l-.767-4.471,3.249-3.167a.465.465,0,0,0-.258-.793Z",
    transform: "translate(-77.639 -85.323)",
    fill: "#ffce56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7688",
    "data-name": "Trazado 7688",
    d: "M345.122,244.076a.452.452,0,0,0,.128.128.457.457,0,0,0,.081.043.47.47,0,0,0,.087.027.447.447,0,0,0,.181,0,.487.487,0,0,0,.087-.027.468.468,0,0,0,.08-.043.451.451,0,0,0,.128-.128.471.471,0,0,0,.069-.167.454.454,0,0,0,.009-.091.474.474,0,0,0-.036-.178.446.446,0,0,0-.043-.08.451.451,0,0,0-.058-.071.482.482,0,0,0-.071-.058.473.473,0,0,0-.08-.043.482.482,0,0,0-.087-.026.459.459,0,0,0-.181,0,.472.472,0,0,0-.087.026.462.462,0,0,0-.081.043.479.479,0,0,0-.071.058.448.448,0,0,0-.058.071.472.472,0,0,0-.043.08.457.457,0,0,0-.026.087.467.467,0,0,0-.009.091.458.458,0,0,0,.009.091.441.441,0,0,0,.026.087A.468.468,0,0,0,345.122,244.076Z",
    transform: "translate(-330.623 -190.522)",
    fill: "#ffce56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7689",
    "data-name": "Trazado 7689",
    d: "M348.853,47.092a.465.465,0,0,0-.376-.317l-1.895-.275-.847-1.717a.465.465,0,0,0-.834,0l-.847,1.717-1.895.275a.465.465,0,0,0-.258.793l1.371,1.336-.324,1.887a.465.465,0,0,0,.675.49l1.695-.891,1.695.891a.465.465,0,0,0,.675-.49l-.324-1.887,1.371-1.336A.465.465,0,0,0,348.853,47.092ZM346.54,48.41a.465.465,0,0,0-.134.412l.206,1.2-1.077-.566a.465.465,0,0,0-.433,0l-1.077.566.206-1.2a.465.465,0,0,0-.134-.412l-.871-.849,1.2-.175a.465.465,0,0,0,.35-.254l.538-1.091.538,1.091a.465.465,0,0,0,.35.254l1.2.175Z",
    transform: "translate(-327.478 -0.003)",
    fill: "#ffce56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7690",
    "data-name": "Trazado 7690",
    d: "M5.252,51.28a.465.465,0,0,0,.675-.49L5.6,48.9l1.371-1.336a.465.465,0,0,0-.258-.793L4.821,46.5,3.974,44.78a.465.465,0,0,0-.834,0L2.293,46.5.4,46.772a.465.465,0,0,0-.258.793L1.511,48.9l-.324,1.887a.465.465,0,0,0,.675.49l1.695-.891ZM2.264,50.018l.206-1.2a.465.465,0,0,0-.134-.412l-.871-.849,1.2-.175a.465.465,0,0,0,.35-.254l.538-1.091L4.1,47.128a.465.465,0,0,0,.35.254l1.2.175-.871.849a.465.465,0,0,0-.134.412l.206,1.2-1.077-.566a.465.465,0,0,0-.433,0Z",
    transform: "translate(0)",
    fill: "#ffce56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.9654001210c93057b4fe6b56cce69198.svg";
export { ForwardRef as ReactComponent };